import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Number from '../Number';
import AuctioneerDataMatrixRow from './AuctioneerDataMatrixRow';
import { auctioneerDataMatrixItemsType } from '../../types';

export const auctioneerDataMatrixItemSortFunc = (firstItem, secondItem) => {
    let result = firstItem.auctioneer.memberId.localeCompare(secondItem.auctioneer.memberId);
    if (result === 0) {
        result = firstItem.submarket.code.localeCompare(secondItem.submarket.code);
    }
    return result;
};

AuctioneerDataMatrixTable.propTypes = {
    isModifiable: PropTypes.bool.isRequired,
    items: auctioneerDataMatrixItemsType.isRequired,
    removeItem: PropTypes.func.isRequired,
    changeQuantity: PropTypes.func.isRequired,
    quantityMultiple: PropTypes.number,
    maxQuantity: PropTypes.number.isRequired,
    doReset: PropTypes.bool.isRequired,
    doResetComponentsAfterModification: PropTypes.bool.isRequired,
    doAdjustValuesAfterTemplateApplied: PropTypes.bool,
    doAdjustValuesAfterExternalUpdate: PropTypes.bool,
};

function AuctioneerDataMatrixTable(props) {
    const {
        isModifiable,
        items,
        removeItem,
        changeQuantity,
        quantityMultiple,
        maxQuantity,
        doReset,
        doResetComponentsAfterModification,
        doAdjustValuesAfterTemplateApplied = false,
        doAdjustValuesAfterExternalUpdate = false,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="auctioneer-data-matrix--table detail-list">
            <div className="detail-list-row detail-list-header">
                {isModifiable && (
                    <div className="auctioneer-data-matrix-cell--small">&nbsp;</div>
                )}
                <div className="auctioneer-data-matrix-cell">{t('auctioneer-data-matrix.member-name')}</div>
                <div className="auctioneer-data-matrix-cell">{t('auctioneer-data-matrix.member-id')}</div>
                <div className="auctioneer-data-matrix-cell">{t('auctioneer-data-matrix.submarket-name')}</div>
                <div className="auctioneer-data-matrix-cell">{t('auctioneer-data-matrix.submarket-code')}</div>
                <div className="auctioneer-data-matrix-cell">{t('auctioneer-data-matrix.quantity')}</div>
            </div>
            {items.sort(auctioneerDataMatrixItemSortFunc).map((item) => (
                <AuctioneerDataMatrixRow
                    key={`${item.auctioneer.memberId}-${item.submarket.code}`}
                    item={item}
                    onRemoveItem={removeItem(item)}
                    onQuantityChange={changeQuantity(item)}
                    quantityMultiple={quantityMultiple}
                    maxQuantity={maxQuantity}
                    isModifiable={isModifiable}
                    doReset={doReset}
                    doResetComponentsAfterModification={doResetComponentsAfterModification}
                    doAdjustValuesAfterTemplateApplied={doAdjustValuesAfterTemplateApplied}
                    doAdjustValuesAfterExternalUpdate={doAdjustValuesAfterExternalUpdate}
                />
            ))}
            <div className="detail-list-row auctioneer-data-matrix--table--sum-row">
                <div className="auctioneer-data-matrix-cell auctioneer-data-matrix-row--sum-title">
                    {t('auctioneer-data-matrix.sum')}
                </div>
                <div className="auctioneer-data-matrix-cell auctioneer-data-matrix-row--sum-value">
                    <Number value={items.reduce((a, currentValue) => a + currentValue.quantity, 0)} />
                </div>
            </div>
        </div>
    );
}

export default AuctioneerDataMatrixTable;
